
const S = Object.assign(
  {
    adding: 'Adding…',
    added: 'Added',
    addToCart: 'Add to cart',
    soldOut: 'Sold out',
    unavailable: 'Unavailable',
    errorGeneric: 'Sorry, we could not add that to your cart. Please try again.',
    errorUnavailable: 'That item is no longer available.',
    errorOffline: 'You appear to be offline. Check your connection and try again.',
    errorQuantity: 'We could not update that quantity.',
    errorUpdate: 'Could not update your cart.',
  },
  window.themeStrings || {}
);

class SiteDrawer {
  constructor(el) {
    this.el = el;
    this.lastFocus = null;
    el.querySelectorAll('[data-drawer-close]').forEach((btn) =>
      btn.addEventListener('click', () => this.close())
    );
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
      if (e.key === 'Tab') this.trap(e);
    });
  }

  open() {
    this.lastFocus = document.activeElement;
    this.el.classList.add('is-open');
    this.el.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    const focusable = this.focusable();
    if (focusable.length) focusable[0].focus();
  }

  close() {
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (this.lastFocus) this.lastFocus.focus();
  }

  focusable() {
    return Array.from(
      this.el.querySelectorAll(
        'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((n) => n.offsetParent !== null);
  }

  trap(e) {
    const nodes = this.focusable();
    if (!nodes.length) return;
    const first = nodes[0];
    const last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
}

const drawers = {};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-drawer]').forEach((el) => {
    drawers[el.dataset.drawer] = new SiteDrawer(el);
  });

  document.querySelectorAll('[data-drawer-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const target = drawers[btn.dataset.drawerOpen];
      if (target) target.open();
    });
  });
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-qty]');
  if (!btn) return;
  const input = btn.parentElement.querySelector('input');
  if (!input) return;
  const step = btn.dataset.qty === 'up' ? 1 : -1;
  const min = parseInt(input.min || '1', 10);
  input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

async function refreshCart() {
  const _done = (c) => document.dispatchEvent(new CustomEvent('cart:updated', { detail: c }));
  const res = await fetch('/?section_id=cart-drawer');
  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const fresh = doc.querySelector('[data-cart-contents]');
  const current = document.querySelector('[data-cart-contents]');
  if (fresh && current) current.innerHTML = fresh.innerHTML;

  const cart = await (await fetch('/cart.js')).json();
  _done(cart);
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    el.textContent = cart.item_count;
    el.hidden = cart.item_count === 0;
  });
}

document.addEventListener('click', async (e) => {
  const link = e.target.closest('[data-line-change]');
  if (!link) return;
  e.preventDefault();
  const live = document.getElementById('cart-live-region');

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: parseInt(link.dataset.line, 10),
        quantity: parseInt(link.dataset.lineChange, 10),
      }),
    });
    const data = await res.json().catch(() => null);

    if (!res.ok) {

      if (live) {
        live.textContent =
          (data && (data.description || data.message)) ||
          S.errorQuantity;
      }
      return;
    }
    if (live) live.textContent = '';
    await refreshCart();
  } catch (err) {
    if (live) live.textContent = S.errorUpdate;
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header]');
  if (!header) return;

  const bar = document.querySelector('[data-announcement]');
  const setBarHeight = () =>
    document.documentElement.style.setProperty('--announcement-h', (bar ? bar.offsetHeight : 0) + 'px');
  setBarHeight();

  const scroller = () => {
    const s = document.querySelector('[data-page-scroll]');
    return s && getComputedStyle(s).overflowY === 'auto' ? s : null;
  };
  const scrollTop = () => (scroller() ? scroller().scrollTop : window.scrollY);
  window.amansScroller = scroller;
  const setScrolled = () => header.classList.toggle('is-scrolled', scrollTop() > 8);
  document.querySelector('[data-page-scroll]')?.addEventListener('scroll', setScrolled, { passive: true });
  setScrolled();
  window.addEventListener('scroll', setScrolled, { passive: true });

  if (!header.classList.contains('header-wrap--can-overlay')) return;

  const MEDIA = '.showcase__media, .hero__media, .slideshow__media, .push__media, .store__media';
  const main = document.querySelector('#main') || document.body;
  const firstSection = main.querySelector('.shopify-section');
  const firstMedia = firstSection ? firstSection.querySelector(MEDIA) : null;
  if (!firstMedia) return;

  header.classList.add('header-wrap--overlay');
  firstSection.classList.add('is-under-header');

  const measure = () => {
    if (!header.classList.contains('is-compact')) {
      document.documentElement.style.setProperty('--header-offset', header.offsetHeight + 'px');
    }
  };

  const compact = () => {
    const past = scrollTop() > firstSection.offsetHeight * 0.5;
    header.classList.toggle('is-compact', past);
  };
  document.querySelector('[data-page-scroll]')?.addEventListener('scroll', compact, { passive: true });
  window.addEventListener('scroll', compact, { passive: true });
  compact();

  const syncColour = () => header.classList.add('is-over-media');

  const update = () => { setBarHeight(); measure(); syncColour(); };
  update();
  window.addEventListener('scroll', syncColour, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('load', update);
  if ('ResizeObserver' in window) new ResizeObserver(update).observe(header);
});

document.addEventListener('click', (e) => {
  if (!e.target.closest('[data-announcement-close]')) return;
  const bar = e.target.closest('[data-announcement]');
  if (bar) bar.remove();
});

class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-results]');
    if (!this.input || !this.results) return;

    let timer;
    this.input.addEventListener('input', () => {
      clearTimeout(timer);
      const term = this.input.value.trim();
      if (term.length < 2) {
        this.close();
        return;
      }
      timer = setTimeout(() => this.search(term), 250);
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.close();
    });
  }

  async search(term) {
    try {
      const url = `/search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;
      const res = await fetch(url);
      if (!res.ok) throw new Error('search failed');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-predictive-results]');
      if (!fresh) return;
      this.results.innerHTML = fresh.innerHTML;
      this.results.hidden = false;
      this.setAttribute('aria-expanded', 'true');
    } catch (e) {
      this.close();
    }
  }

  close() {
    this.results.hidden = true;
    this.setAttribute('aria-expanded', 'false');
  }
}
customElements.define('predictive-search', PredictiveSearch);

document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('[data-back-to-top]');
  if (!btn) return;
  const box = () => (window.amansScroller && window.amansScroller()) || null;
  const sync = () => btn.classList.toggle('is-visible', (box() ? box().scrollTop : window.scrollY) > 600);
  document.querySelector('[data-page-scroll]')?.addEventListener('scroll', sync, { passive: true });
  sync();
  window.addEventListener('scroll', sync, { passive: true });
  btn.addEventListener('click', () =>
    (box() || window).scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' })
  );
});

document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.reveal');
  if (!targets.length || !('IntersectionObserver' in window)) {
    targets.forEach((t) => t.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -60px 0px' }
  );
  targets.forEach((t) => io.observe(t));
});

window.refreshCart = typeof refreshCart !== 'undefined' ? refreshCart : window.refreshCart;

window.drawers = typeof drawers !== 'undefined' ? drawers : window.drawers;

window.S = typeof S !== 'undefined' ? S : window.S;
